import PropTypes from 'prop-types';
import { useTranslation } from './useTranslation';
import { MenuItem, Select } from '@mui/material';
import { themeColors } from '../theme/theme';

export function Dropdown({ options = [], value, onChange, placeholder, label, ...props }) {
  const { t, language } = useTranslation();
  const translatedPlaceholder = placeholder ? t(placeholder) : undefined;
  const translatedLabel = label ? t(label) : undefined;

  return (
    <div style={{ width: '100%' }}>
      {translatedLabel && (
        <label
          style={{
            display: 'block',
            marginBottom: 4,
            fontWeight: 500,
            fontFamily: themeColors.fontFamily,
            fontSize: '1rem',
          }}
          lang={language}
        >
          {translatedLabel}
        </label>
      )}
      <Select
        value={value}
        onChange={onChange}
        lang={language}
        displayEmpty
        style={{
          borderRadius: 6,
          fontSize: '1rem',
          color: themeColors.textColor,
          background: themeColors.backgroundColor,
          fontFamily: themeColors.fontFamily,
          width: '100%',
        }}
        {...props}
      >
        {translatedPlaceholder && (
          <MenuItem value="" disabled>
            {translatedPlaceholder}
          </MenuItem>
        )}
        {options.map((option) => (
          <MenuItem
            key={option.value}
            value={option.value}
            style={{ fontFamily: themeColors.fontFamily, fontSize: '1rem' }}
          >
            {t(option.label)}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
}

Dropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({ value: PropTypes.any, label: PropTypes.string })),
  value: PropTypes.any,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  label: PropTypes.string,
};
